import React from 'react';
import { Layout } from '../components/Layout';
import { SEO } from '../components/SEO';
import { Mail, Shield } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <Layout data-id="element-1730">
      <SEO title="Politique de Confidentialité" description="Politique de confidentialité de l'ADCC Bénin. Découvrez comment nous collectons, utilisons et protégeons vos données personnelles." keywords="politique de confidentialité, ADCC Bénin, protection données personnelles, RGPD" url="https://adcc.africa/privacy-policy" data-id="element-1731" />

      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-1732">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1733">
          <div className="flex justify-center mb-4" data-id="element-1734">
            <Shield className="w-12 h-12 text-[#1E88E5]" data-id="element-1735" />
          </div>
          <h1 className="text-4xl font-bold mb-4" data-id="element-1736">
            Politique de Confidentialité
          </h1>
          <p className="text-gray-300" data-id="element-1737">ADCC Africa</p>
        </div>
      </div>

      {/* Content */}
      <section className="py-16 bg-white" data-id="element-1738">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1739">
          <p className="text-sm text-gray-500 mb-10" data-id="element-1740">
            Dernière mise à jour : 2026
          </p>

          <p className="text-gray-700 leading-relaxed mb-10" data-id="element-1741">
            ADCC Africa (« nous », « notre », « nos ») collecte et traite les
            données personnelles soumises via les formulaires de ce site web.
          </p>

          {/* Data we collect */}
          <div className="mb-10" data-id="element-1742">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1743">
              Données collectées
            </h2>
            <ul className="space-y-2 text-gray-700" data-id="element-1744">
              <li className="flex items-start gap-2" data-id="element-1745">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1746">●</span>
                <span data-id="element-1747">Nom</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1748">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1749">●</span>
                <span data-id="element-1750">Adresse email</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1751">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1752">●</span>
                <span data-id="element-1753">Numéro de téléphone</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1754">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1755">●</span>
                <span data-id="element-1756">Contenu des messages</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1757">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1758">●</span>
                <span data-id="element-1759">Données techniques (adresse IP, navigateur)</span>
              </li>
            </ul>
          </div>

          {/* Purpose */}
          <div className="mb-10" data-id="element-1760">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1761">Finalité</h2>
            <p className="text-gray-700 mb-3" data-id="element-1762">
              Nous utilisons ces données pour :
            </p>
            <ul className="space-y-2 text-gray-700" data-id="element-1763">
              <li className="flex items-start gap-2" data-id="element-1764">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1765">●</span>
                <span data-id="element-1766">Répondre aux demandes</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1767">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1768">●</span>
                <span data-id="element-1769">Fournir les services demandés</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1770">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1771">●</span>
                <span data-id="element-1772">Gérer les relations professionnelles</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1773">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1774">●</span>
                <span data-id="element-1775">Améliorer notre site web</span>
              </li>
            </ul>
          </div>

          {/* Legal basis */}
          <div className="mb-10" data-id="element-1776">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1777">
              Base légale
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1778">
              Les données sont traitées sur la base du consentement de
              l'utilisateur et de l'intérêt légitime de l'organisation.
            </p>
          </div>

          {/* Data sharing */}
          <div className="mb-10" data-id="element-1779">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1780">
              Partage des données
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1781">
              Nous ne vendons pas de données personnelles. Les données peuvent
              être traitées par des prestataires de confiance (hébergement,
              email, analytics, outils de formulaires) uniquement à des fins
              opérationnelles.
            </p>
          </div>

          {/* Data storage */}
          <div className="mb-10" data-id="element-1782">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1783">
              Stockage des données
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1784">
              Les données sont stockées de manière sécurisée et conservées
              uniquement le temps nécessaire aux obligations professionnelles ou
              légales.
            </p>
          </div>

          {/* User rights */}
          <div className="mb-10" data-id="element-1785">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1786">
              Droits des utilisateurs
            </h2>
            <p className="text-gray-700 mb-3" data-id="element-1787">Vous pouvez demander :</p>
            <ul className="space-y-2 text-gray-700" data-id="element-1788">
              <li className="flex items-start gap-2" data-id="element-1789">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1790">●</span>
                <span data-id="element-1791">L'accès à vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1792">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1793">●</span>
                <span data-id="element-1794">La correction de vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1795">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1796">●</span>
                <span data-id="element-1797">La suppression de vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1798">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1799">●</span>
                <span data-id="element-1800">Le retrait de votre consentement</span>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2 text-gray-700" data-id="element-1801">
              <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-1802" />
              <span data-id="element-1803">
                Contact :{' '}
                <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1804">
                  contact@adcc.africa
                </a>
              </span>
            </div>
          </div>

          {/* Cookies */}
          <div className="mb-10" data-id="element-1805">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1806">Cookies</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1807">
              Ce site web peut utiliser des cookies à des fins d'analyse et de
              fonctionnalité.
            </p>
          </div>

          {/* Contact */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1808">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1809">Contact</h2>
            <p className="text-gray-700" data-id="element-1810">ADCC Africa</p>
            <p className="text-gray-700 flex items-center gap-2 mt-2" data-id="element-1811">
              <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-1812" />
              <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1813">
                contact@adcc.africa
              </a>
            </p>
            <p className="text-gray-700 mt-2" data-id="element-1814">
              Site web :{' '}
              <a href="https://www.adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1815">
                https://www.adcc.africa
              </a>
            </p>
          </div>
        </div>
      </section>
    </Layout>;
}